import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Parser from "html-react-parser";
import { pointFn } from "../../components/logic";
import PlusMinusBtn from "./PlusMinusBtn";
import Btn from "../../components/common/Btn";
import GuideForFood from "./GuideForFood";

const SearchDialog = ({
  boxRef,
  boxStatus,
  keyword,
  setValue,
  setBoxStatus,
  openDialog,
  setOpenDialog,
  onSaveAddorEdit,
  noFoodOpen,
  setNoFoodOpen,
  searchedFoodLists,
}) => {
    const navigate = useNavigate();
  const { recentFoodLists } = useSelector(
    (state) => state.meal
  );
  const [chosenFood, setChosenFood] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [openGuide, setOpenGuide] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnDisabled2, setBtnDisabled2] = useState(false);
  const [i, setI] = useState(0); // For multiples: 2, 3, 4...

  const foodFn = (food, idx, ref = null) => {
    return idx === 0 ? (
      <li
        ref={ref}
        onClick={() => {
          setValue(food.foodnameOrg);
          setBoxStatus("addQty");
          setChosenFood(food);
          setQuantity(food.eyemesurementnumber);
        }}
        key={idx}
        className="inline-block p-3 mb-3 mr-3 text-black rounded-xl bg-gray_20 text-body2_600"
      >
        {food.foodname ? Parser(food.foodname) : null}
      </li>
    ) : (
      <li
        onClick={() => {
          setValue(food.foodnameOrg);
          setBoxStatus("addQty");
          setChosenFood(food);
          setQuantity(food.eyemesurementnumber);
        }}
        key={idx}
        className="inline-block p-3 mb-3 mr-3 text-black rounded-xl bg-gray_20 text-body2_600"
      >
        {food.foodname ? Parser(food.foodname) : null}
      </li>
    );
  };

  const onIncreaseQty = (qty) => {
    setBtnDisabled(false);
    if (qty === 1 || qty === 0.25) {
      if (quantity + Number(qty) > 500) {
        setBtnDisabled2(true);
      } else {
        setBtnDisabled2(false);
        setQuantity(quantity + Number(qty));
      }
    } else {
      if (i <= 100) {
        if (chosenFood.eyemesurementnumber * (2 + i) > 500) {
          setBtnDisabled2(true);
        } else {
          setBtnDisabled2(false);
          setQuantity(chosenFood.eyemesurementnumber * (2 + i));
          setI(i + 1);
        }
      } else if (i === 0) {
        setBtnDisabled2(false);
        setQuantity(chosenFood.eyemesurementnumber);
        setI(i + 1);
      } else {
        setBtnDisabled2(true);
      }
    }
  };

  const onDecreaseQty = (qty) => {
    setBtnDisabled2(false);
    if (qty === 1 || qty === 0.25) {
      if (quantity - Number(qty) <= 0 || quantity - Number(qty) < 0.1) {
        setBtnDisabled(true);
      } else {
        setBtnDisabled(false);
        setQuantity(quantity - Number(qty));
      }
    } else {
      if (quantity / Number(qty) <= 0 || quantity / Number(qty) < 0.1) {
        setBtnDisabled(true);
      } else {
        if (i > 0) {
          setBtnDisabled(false);
          setQuantity(chosenFood.eyemesurementnumber * i);
          setI(i - 1);
        } else {
          setBtnDisabled(false);
          setQuantity(quantity / Number(qty));
        }
      }
    }
  };

  const getTotalLength = (arr) => {
    const margin = 1.5;
    const padding = 3;
    const combinedString = arr.reduce(
      (accumulator, current) =>
        accumulator +
        current.length +
        (current.length - 1) +
        margin * 2 +
        padding * 2,
      0
    );
    return combinedString;
  };

  const calculateSplitPoint = (arr) => {
    const margin = 1.5;
    const padding = 3;
    if (arr.length <= 2) return 1;
    try {
      const strings = arr.map((e) => e.foodnameOrg);
      const midPoint = getTotalLength(strings) / 2;
      let optimalMidPoint = 0;
      for (let [index, item] of strings.entries()) {
        optimalMidPoint +=
          item.length + (item.length - 1) + margin * 2 + padding * 2;
        if (optimalMidPoint >= midPoint) {
          return index + 1;
        }
      }
    } catch (e) {
      return 15;
    }
  };

  // eyemesurementnumber_org: original 1 serving eye measurement (0.8 bowl), eyemesurementnumber: user's consumed amount, servingsize: 1 serving size (200g), servingsize_org: original 1 serving size
  // Result value: max 500, min 0.1
  // When integer: >= 3: +- 1, < 3: +-0.25
  // When decimal: x % 0.25===0: +-0.25, x % 0.25!==0: * / multiples 2,3,4,5...
  // Disabled from 0.1 or less
  return (
    <>
      {boxStatus === "search" ? (
        noFoodOpen ? (
          <div
            className={
              "maxW fixed left-0 right-0 z-10 mx-auto rounded-t-[32px] bg-white shadow-[0_0_12px_rgba(0,0,0,0.1)] duration-300 ease-in-out " +
              (openDialog ? "max-h-[50vh] top-[200px] bottom-0" : "top-[100vh] max-h-[50vh]")
            }
          >
            <div className="flex items-center justify-between maxW">
              <h1 className="my-[22px] ml-6 text-body3_700 text-gray_160">
                {keyword ? "Search Results" : "Recent Foods"}
              </h1>
              <img
                onClick={() => {
                  setOpenDialog(false);
                  setValue(null);
                  setNoFoodOpen(false);
                }}
                src="/images/mobile/icon/close.svg"
                alt="Close"
                className="mr-4"
              />
            </div>
            <div className="mx-6 space-y-[19px]">
              <p className="text-center text-body3_700 text-gray_160">
                No results found for
                <br />
                '<span className="text-main">{keyword}</span>'
              </p>
              <Btn
                id={"noFoodReport"}
                textColor={"text-main"}
                borderColor={"border border-main"}
                title="Request Food Addition"
                active={"on"}
                onAction={() => navigate(`/meal/request`)}
              />
            </div>
          </div>
        ) : (
          // took out overflow-hidden from the div below
          <div
            className={
              "maxW fixed left-0 right-0 z-10 mx-auto rounded-t-[32px] bg-white shadow-[0_0_12px_rgba(0,0,0,0.1)] duration-300 ease-in-out " +
              (openDialog ? "max-h-[50vh] top-[200px] bottom-0" : "top-[100vh] max-h-[50vh]")
            }
          >
            <div className="flex items-center justify-between maxW">
              <h1 className="my-[22px] ml-6 text-body3_700 text-gray_160">
                {keyword ? "Search Results" : "Recent Foods"}
              </h1>
              <img
                onClick={() => setOpenDialog(false)}
                src="/images/mobile/icon/close.svg"
                alt="Close"
                className="mr-4"
              />
            </div>
            <div className="overflow-scroll pb-0">
              <div
                className={
                  "pl-[19px] pb-0 " +
                  (keyword && searchedFoodLists?.length < 1
                    ? ""
                    : "w-max overflow-scroll ")
                }
              >
                <ul className="w-full">
                  {keyword && searchedFoodLists?.length > 0
                    ? searchedFoodLists
                        .slice(0, calculateSplitPoint(searchedFoodLists))
                        .map((food, idx) => foodFn(food, idx, boxRef))
                    : recentFoodLists &&
                      recentFoodLists
                        .slice(0, calculateSplitPoint(recentFoodLists))
                        .map((food, idx) => foodFn(food, idx, boxRef))}
                </ul>
                <ul className="w-full">
                  {keyword && searchedFoodLists?.length > 0
                    ? searchedFoodLists
                        .slice(calculateSplitPoint(searchedFoodLists))
                        .map((food, idx) => foodFn(food, idx))
                    : recentFoodLists &&
                      recentFoodLists
                        .slice(calculateSplitPoint(recentFoodLists))
                        .map((food, idx) => foodFn(food, idx))}
                </ul>

                {/* <ul ref={boxRef}>
															{(keyword && searchedFoodStatus === 'success') ?
																	searchedFoodLists && searchedFoodLists.map((food, idx) => foodFn(food, idx))
																	: recentFoodLists && recentFoodLists.map((food, idx) => foodFn(food, idx))}
													</ul> */}
              </div>
            </div>
          </div>
        )
      ) : boxStatus === "addQty" && chosenFood ? (
        <>
          <div
            className={
              "maxW fixed left-0 right-0 z-10 mx-auto h-[300px] rounded-t-[32px] bg-white p-6 shadow-[0_0_12px_rgba(0,0,0,0.1)] duration-700 ease-in-out " +
              (openDialog ? "top-[200px] bottom-0" : "top-[100vh]")
            }
          >
            <div className="flex items-center justify-between overflow-hidden maxW">
              <h1 className="text-black text-subtitle2">{keyword}</h1>
              <img
                onClick={() => {
                  setOpenDialog(false);
                  setValue(null);
                  setBoxStatus("search");
                }}
                src="/images/mobile/icon/close.svg"
                alt="Close"
              />
            </div>
            <div className="mt-3 space-y-2">
              <div className="flex justify-center gap-2">
                <PlusMinusBtn
                  num={quantity}
                  unit={chosenFood.eyemesurementunit}
                  chosenFood={chosenFood}
                  onIncreaseQty={onIncreaseQty}
                  onDecreaseQty={onDecreaseQty}
                  btnDisabled={btnDisabled}
                  btnDisabled2={btnDisabled2}
                />
                <img
                  onClick={() => setOpenGuide(true)}
                  src="/images/mobile/icon/info_circle.svg"
                  alt="Info"
                />
              </div>
              <ul className="flex justify-center gap-2 text-caption2_700">
                <li className="text-gray_160">
                  Total{" "}
                  {quantity
                    ? pointFn(
                        (
                          (quantity * chosenFood.servingsize_org) /
                          chosenFood.eyemesurementnumber_org
                        ).toFixed(0)
                      )
                    : pointFn(chosenFood.servingsize)}
                  {chosenFood.contentunit.toLowerCase()}
                </li>
                <span className="h-[28px] w-[1px] bg-gray_40"></span>
                <li className="text-orange_180">
                  Calories{" "}
                  {quantity
                    ? pointFn(
                        (
                          (quantity * chosenFood.kcal_org) /
                          chosenFood.eyemesurementnumber_org
                        ).toFixed(0)
                      )
                    : pointFn(chosenFood.kcal)}
                  kcal
                </li>
                <span className="h-[28px] w-[1px] bg-gray_40"></span>
                <li className="text-green_160">
                  Protein{" "}
                  {quantity
                    ? pointFn(
                        (
                          (quantity * chosenFood.proteinG_org) /
                          chosenFood.eyemesurementnumber_org
                        ).toFixed(0)
                      )
                    : pointFn(chosenFood.proteinG)}
                  g
                </li>
              </ul>
            </div>
            <div className="mt-4">
              <Btn
                bgColor={"bg-main"}
                textColor={"text-white font-semibold"}
                borderColor={"border border-main"}
                title="Record Complete"
                active={"on"}
                onAction={() => {
                  onSaveAddorEdit({
                    eyemesurementnumber: quantity,
                    foodId: chosenFood.id,
                  });
                  setOpenDialog(false);
                }}
              />
            </div>
          </div>
          {<GuideForFood openGuide={openGuide} setOpenGuide={setOpenGuide} />}
        </>
      ) : null}
    </>
  );
};

export default SearchDialog;
